import { WarningLine } from '@/pages/studies-list/@x/study-management';
import { redClockIcon } from '@/shared/ui/assets';
import { symptomsFormatter } from '@/entities/study';
import dayjs from 'dayjs';
import { t } from 'ttag';
import type { InfoECGProps } from './infoECG.types';

const EMPTY_ARRAY: any[] = [];

const InfoECG = ({
  conflictUsers = EMPTY_ARRAY,
  data,
  isNotCanEdit = false,
  hasIcon = false,
}: InfoECGProps) => {
  /**
   * Flags events whose upload is older than the one-hour SLA. Computes the fractional hour difference from now and renders a red clock icon only when it exceeds one hour.
   *
   * @param uploadTime - Timestamp the event was uploaded at.
   * @returns The clock icon element, or false when still inside the SLA.
   */
  const generateSLAClickIcon = (uploadTime: any) => {
    const hoursDiff = dayjs().diff(uploadTime, 'hours', true);
    return hoursDiff > 1 && <img className="sla-icon" src={redClockIcon} alt="Clock icon" />;
  };

  return (
    <>
      {conflictUsers.length > 0 && (
        <WarningLine isEventsPage conflictUsers={conflictUsers} isNotCanEdit={isNotCanEdit} />
      )}

      <div className="info-ecg w-100 flex-row__is">
        <div className="info-ecg__group flex-row w-20">
          <div className="info-ecg__title flex-col__is">
            <span>{`${t`Event type`}:`}</span>
            <span>{`${t`Validity`}:`}</span>
          </div>
          <div className="info-ecg__text flex-col__is">
            <span>{data.eventType}</span>
            <span>{data.isValid ? t`Valid` : t`Invalid`}</span>
          </div>
        </div>

        <div className="info-ecg__group flex-row w-30">
          <div className="info-ecg__title flex-col__is">
            <span>{`${t`Diagnosis lead`}:`}</span>
            <span>{`${t`Symptoms`}:`}</span>
          </div>
          <div className="info-ecg__text flex-col__is">
            <span>{data.diagnosticLead}</span>
            <span>{symptomsFormatter(data.symptoms)}</span>
          </div>
        </div>

        <div className="info-ecg__group flex-row w-50">
          <div className="info-ecg__title flex-col__is">
            <span>{`${t`Trigger time`}:`}</span>
            <span>{`${t`Upload time`}:`}</span>
          </div>
          <div className="info-ecg__text flex-col__is">
            <span>{data.triggerTime}</span>

            <div className="time-with-sla-container">
              <span className="time">{data.uploadTime}</span>

              {hasIcon && generateSLAClickIcon(data.uploadTime)}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InfoECG;
